<p-treeTable
  [value]="customers"
  [columns]="cols"
  [(selection)]="selectedCustomers"
  [paginator]="true"
  [rows]="10"
  [lazy]="false"
  [loading]="isLoading"
  [resizableColumns]="true"
  [rowsPerPageOptions]="[10, 20]"
>
  <ng-template pTemplate="caption">
    <div style="text-align: left">Customer, Departments and Teams</div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th pResizableColumn *ngFor="let col of columns">
        {{ col.header }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
    <tr>
      <td *ngFor="let col of columns; let i = index">
        <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
        <p-checkbox
          [binary]="true"
          *ngIf="i == 0"
          [disabled]="parentChecked(rowNode)"
          [ngModel]="isRowSelected(rowNode)"
          (click)="toggleRowSelection(rowNode)"
        >
        </p-checkbox>
        <span *ngIf="i == 0">{{ rowData[col.field] }}</span>
        <!-- only col 0 can be shown as-is, the others require code below -->

        <div
          class="exclude-suppliers-node"
          *ngIf="
            col.field == 'orderPreferences' && rowData[col.field] && rowData[col.field].length > 0
          "
        >
          <div class="exclude-suppliers-list">
            <ol>
              <li *ngFor="let excluded of rowData[col.field]">
                {{ excluded.targetOrganisation.name }}
              </li>
            </ol>
          </div>
          <div class="exclude-suppliers-reason" *ngIf="customerHasPreferences(rowNode)">
            Reason: {{ rowData[col.field][0].reason }}
          </div>
        </div>

        <div *ngIf="col.field == 'tags'">
          <tagging-tags-details
            [organisationTags]="rowData[col.field]"
            [readOnly]="true"
          ></tagging-tags-details>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary">
    <div style="text-align: left">
      Selected Nodes:
      <span *ngIf="!selectedCustomers || selectedCustomers.length === 0" style="font-weight: normal"
        >none</span
      >
      <ol *ngIf="selectedCustomers && selectedCustomers.length">
        <li *ngFor="let node of selectedCustomers">
          <span style="font-weight: normal">{{ getNodeName(node) }}</span>
        </li>
      </ol>
    </div>
  </ng-template>
</p-treeTable>
